import moment from 'moment'

const getDateRanges = (option, specialDate) => {

  const unitTimeType = {
    YEAR: 'year',
    QUARTER: 'quarter',
    MONTH: 'month',
    WEEK: 'week',
    DAY: 'day'
}

  const format = 'YYYY-MM-DD'
  const today = moment().format(format)

  const getPreviousRange = (startDate, endDate) => {
    // This duration should be negative assuming startDate < endDate
    const duration = moment.duration(moment(startDate).diff(moment(endDate)));

    // previous range needs to have the same number of days as current
    const previousEndDate = moment(startDate).subtract(1, unitTimeType.DAY).format(format);
    const previousStartDate = moment(previousEndDate).add(duration).format(format);

    return [previousStartDate, previousEndDate];
  }

  const calendarDuration = (unitTime, offset = 0) => {
    const startCurrent = moment(today).subtract(offset, unitTime).startOf(unitTime).format(format)
    const endCurrent = moment(today).subtract(offset, unitTime).endOf(unitTime).format(format)
    return {
      current: [startCurrent, endCurrent],
      previous: getPreviousRange(startCurrent, endCurrent)
    };
  }

  const fixedDuration = (unitTime, length, offset = 0) => {
    const startCurrent = moment(today).subtract(length - 1, unitTime).format(format)
    return {
      current: [startCurrent, today],
      previous: getPreviousRange(startCurrent, today)
    };
  }

  const sinceLastUpdateDuration = () => {
    const lastUpdateDate = moment(specialDate).format(format);
    return {
      current: [lastUpdateDate, today],
      previous: getPreviousRange(lastUpdateDate, today)
    }
  }

  const ranges = {
    'forever': {
      current: [moment(specialDate).format(format), today],
      previous: [moment(specialDate).format(format), today],
    },
    'current_week': calendarDuration(unitTimeType.WEEK),
    'previous_week': calendarDuration(unitTimeType.WEEK, 1),
    'current_month': calendarDuration(unitTimeType.MONTH),
    'previous_month': calendarDuration(unitTimeType.MONTH, 1),
    'last_update': sinceLastUpdateDuration(),
    'last_30_days': fixedDuration(unitTimeType.DAY, 30)
  }

  return ranges[option]
}

export default getDateRanges
